import { Alert, AlertTitle, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export const FullScreenError = ({ text }: { text?: string }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Alert severity="error">
        <AlertTitle>Ooops...</AlertTitle>
        {text ?? t("common.generalError")}
      </Alert>
    </Box>
  );
};
